export enum NoteLocationEnum {
  ORDER_HISTORY = 0,
  ORDER_DETAILS = 1,
}
